import { render, staticRenderFns } from "./KeywordsTags.vue?vue&type=template&id=4fe6b574"
import script from "./KeywordsTags.vue?vue&type=script&lang=js"
export * from "./KeywordsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports